import { Stack } from '@chakra-ui/react'
import FirestoreUser from '../../../../types/FirestoreUser'
import { RoleChangeHistory } from './RoleChangeHistory'
import { DiagnosisChangeHistory } from './DiagnosisChangeHistory'

interface Props {
  user: FirestoreUser
}

/**
 * Container for all user history sections (role changes, diagnosis changes)
 * Displayed below Studies section on the admin user page
 */
export function UserHistorySection({ user }: Props) {
  const hasRoleHistory =
    user.roleChangeHistory && user.roleChangeHistory.length > 0
  const hasDiagnosisHistory =
    (user.diagnosisChangeHistory && user.diagnosisChangeHistory.length > 0) ||
    (user.diagnosisDocumentDeletions &&
      user.diagnosisDocumentDeletions.length > 0)

  // Don't render section if no history
  if (!hasRoleHistory && !hasDiagnosisHistory) return null

  return (
    <Stack spacing={0} mt={4}>
      <RoleChangeHistory roleChangeHistory={user.roleChangeHistory} />
      <DiagnosisChangeHistory
        diagnosisChangeHistory={user.diagnosisChangeHistory}
        diagnosisDocumentDeletions={user.diagnosisDocumentDeletions}
      />
    </Stack>
  )
}
